import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Container,
  CssBaseline,
  Stack,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
  FormControlLabel,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { alpha } from '@mui/material/styles';
import AppNavbar from '../../../components/AppNavbar';
import Header from '../../../components/Header';
import SideMenu from '../../../components/SideMenu';
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from '../../dashboard/theme/customizations';
import AppTheme from '../../../shared-theme/AppTheme';
import { Add, CheckCircle, DragIndicator, RemoveCircleOutline } from '@mui/icons-material';
import { DndContext, closestCenter } from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { tiposCampos,catInventarioCamposObligatorios,catInventarioGenericoCamposObligatorios } from '../../../utils/staticvariables';
import InventarioTypeSelector from './components/inventarioTypeSelector';
import { fetchCategorias } from '../../../utils/generalsFetch';
import { capitalizeFirstLetter } from '../../../utils/generalFunctions';



const SortableItem = ({ field, categoriaId, onChange, onRemove,handleKeyDown, handleRemoveOption }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
    } = useSortable({ id: field.id });
  
    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      border: '1px solid #e0e0e0',
      borderRadius: 8,
      padding: 16,
      backgroundColor: '#fff',
      marginBottom: 16,
    };
    
    if(field==undefined) {
      return;
      }
  
    return (
      <Box ref={setNodeRef} style={style} {...attributes}>
          <Box display="flex" alignItems="center">
  
              <Box display="flex" gap={1} alignItems="center" flexWrap="wrap">
                  <IconButton {...listeners}>
                      <DragIndicator/>
                  </IconButton>

  
                  <TextField
                      disabled={!field.deletelable}
                      value={field.name}
                      onChange={(e) => onChange(categoriaId, field.id, 'name', e.target.value)}
                      placeholder="Nombre del campo"
                      sx={{width:field.id=='id' ? 50 : 300}}
                  />
                  { field.id=='id' && (
                      <TextField
                      value={field.alias}
                      onChange={(e) => onChange(categoriaId, field.id, 'alias', e.target.value)}
                      placeholder="Alias del campo"
                      sx={{minWidth:200}}
                      />
                  )}
                  { field.id=='id' && (
                      <TextField
                      value={field.prefijo}
                      onChange={(e) => onChange(categoriaId, field.id, 'prefijo', e.target.value)}
                      placeholder="Prefijo"
                      sx={{maxWidth:100}}
                      />
                  )}
                  <Select
                      disabled={!field.deletelable}
                      value={field.type}
                      onChange={(e) => onChange(categoriaId, field.id, 'type', e.target.value)}
                      size="small"
                  >
                    {tiposCampos.map((tipo) => (
                      <MenuItem value={tipo.value}>{tipo.label}</MenuItem>
                    ))}
                  </Select>
                  {field.deletelable !== false && (
                  <IconButton onClick={() => onRemove(categoriaId, field.id)}>
                      <RemoveCircleOutline color="error" />
                  </IconButton>
                      )}  

                  <FormControlLabel
                      disabled={!field.deletelable}
                      control={
                      <Switch
                          checked={field.required || false}
                          onChange={(e) => onChange(categoriaId, field.id, 'required', e.target.checked)}
                      />
                      }
                      label="Requerido"
                  />
              </Box>
          </Box>
          {field.type === 'opciones' && (
          <Box py={1}>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1 }}>
              {field.options.map((opt, idx) => (
                <Box key={idx} sx={{ display: 'flex', alignItems: 'center', backgroundColor: '#e0e7ff', color: '#1e40af', px: 1.5, py: 0.5, borderRadius: 1, fontSize: '0.85rem' }}>
                  {opt}
                  {field.deletelable && (
                  <IconButton onClick={() => handleRemoveOption(categoriaId,field.id, idx)} size="small" sx={{ ml: 0.5 }}>
                    <RemoveCircleOutline sx={{ color: 'red' }} fontSize="small" />
                  </IconButton>
                  )}
                </Box>
              ))}
            </Box>
            {field.deletelable && (
            <TextField
              disabled={!field.deletelable}
              placeholder="Escribe tus opciones y presiona Enter o coma"
              value={field.inputValue}
              onChange={(e) => onChange(categoriaId,field.id, 'inputValue', e.target.value)}
              onKeyDown={(e) => handleKeyDown(e, categoriaId,field.id)}
              fullWidth
              size="small"
            />
            )}
          </Box>
           )}
  
      </Box>
    );
  };
  

const xThemeComponents = {
    ...chartsCustomizations,
    ...dataGridCustomizations,
    ...datePickersCustomizations,
    ...treeViewCustomizations,
  };

  
const EditarCategoria = (props) => {
    const [inventarioType, setInventarioType] = useState(props.categoria.tipo)
    const [nombre, setNombre] = useState(props.categoria.label)

    const [nuevaCategoria, setnuevaCategoria] = useState([{
        id: Date.now(),
        nombre: '',
        campos: JSON.parse(props.categoria.fields)
      }
    ]);
      const [activeCategoria, setActiveCategoria] = useState(null);
    
      const [errors, setErrors] = useState({});

    // Validation function
    const validateFields = () => {
      let newErrors = {};
      if (!nombre || nombre.trim() === "") {
        newErrors.nombre = "El nombre de la categoría es obligatorio.";
      }
      if (!inventarioType || inventarioType.trim() === "") {
        newErrors.inventarioType = "El tipo de inventario es obligatorio.";
      }
      // At least one custom field
      if (!nuevaCategoria[0].campos || nuevaCategoria[0].campos.length === 0) {
        newErrors.campos = "Debe agregar al menos un campo personalizado.";
      } else {
        // Check for empty field names
        nuevaCategoria[0].campos.forEach((campo, idx) => {
          if (!campo.name || campo.name.trim() === "") {
            newErrors[`campo_${idx}`] = "El nombre del campo es obligatorio.";
          }
        });
      }
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    };


      async function editarCategoria() {
        if (!validateFields()) {
          return;
        }
        if (!props.categoria.value) {
          setErrors(prev => ({...prev, general: "ID de categoría no definido"}));
          return;
        }
        const url = `${process.env.REACT_APP_SERVER_URL}/api/categorias/${props.categoria.value}`;
        try {
          const response = await fetch(url, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
            },
            body: JSON.stringify({
              nombre: nombre,
              tipo: inventarioType,
              fields: nuevaCategoria[0].campos
            })
          });

          if (!response.ok) {
            const error = await response.json();
            setErrors(prev => ({...prev, general: error.error || 'Error al editar categoría'}));
            throw new Error(error.error || 'Error al editar categoría');
          }
          props.onCancel()

          return await response.json();
        } catch (error) {
          setErrors(prev => ({...prev, general: error.message || 'Error desconocido'}));
          throw error;
        }
      }

      const handleFieldChange = (catId, fieldId, key, value) => {
        setnuevaCategoria(prev =>
          prev.map(cat =>
            cat.id === catId
              ? {
                  ...cat,
                  campos: cat.campos.map(campo =>
                    campo.id === fieldId ? { ...campo, [key]: value } : campo
                  )
                }
              : cat
          )
        );
      };
    
      const handleAddField = (catId) => {
        setnuevaCategoria(prev =>
          prev.map(cat =>
            cat.id === catId
              ? {
                  ...cat,
                  campos: [
                    ...cat.campos,
                    {
                      id: Date.now(),
                      name: '',
                      type: 'texto',
                      required: false,
                      options: [],
                      alias:'',prefijo:'',deletelable: true,
                      inputValue: ''
                    }
                  ]
                }
              : cat
          )
        );
      };
    
      
    
      const handleRemoveField = (catId, fieldId) => {
        setnuevaCategoria(prev =>
          prev.map(cat =>
            cat.id === catId
              ? {
                  ...cat,
                  campos: cat.campos.filter(campo => campo.id !== fieldId)
                }
              : cat
          )
        );
      };
      const handleKeyDown = (e, categoria,id) => {
        if (e.key === 'Enter' || e.key === ',') {
          e.preventDefault();
          handleAddOption(categoria,id);
        }
      };
    
      const handleAddOption = (categoriaId, fieldId) => {
        setnuevaCategoria(prev =>
          prev.map(cat =>
            cat.id === categoriaId
              ? {
                  ...cat,
                  campos: cat.campos.map(field =>{
                    console.log("field",field);
                    const newOption = field.inputValue.trim();
                    if (!newOption) return field;        
                    if(field.id === fieldId){
                        return {
                          ...field,
                          options: [...(field.options || []),  newOption]
                        };
                        }
                    return field
                    }
                  )
                }
              : cat
          )
        );
      };
    
      const handleRemoveOption = (categoriaId, fieldId, optionIndex) => {
        setnuevaCategoria(prev =>
          prev.map(cat =>
            cat.id === categoriaId
              ? {
                  ...cat,
                  campos: cat.campos.map(field =>
                    field.id === fieldId
                      ? {
                          ...field,
                          options: field.options.filter((_, index) => index !== optionIndex)
                        }
                      : field
                  )
                }
              : cat
          )
        );
      };
      
    
      const handleDragEnd = (event) => {
        const { active, over } = event;
        if (!active || !over || active.id === over.id || !activeCategoria) return;
    
        const currentCat = nuevaCategoria.find(c => c.id === activeCategoria);
        if (!currentCat) return;
    
        const oldIndex = currentCat.campos.findIndex(f => f.id === active.id);
        const newIndex = currentCat.campos.findIndex(f => f.id === over.id);
    
        const newCampos = arrayMove(currentCat.campos, oldIndex, newIndex);
    
        setnuevaCategoria(prev =>
          prev.map(cat =>
            cat.id === activeCategoria ? { ...cat, campos: newCampos } : cat
          )
        );
      };
    
    
    
  return (
    <Grid container>
        <Grid item lg={3} sx={{ borderLeft: '1px solid #e0e0e0', pl: { xs: 0, sm: 4 }, mt: { xs: 4, sm: 0 } }}>
            <Typography variant="h5" fontWeight="bold" px={2}>Editar Categoría</Typography>
            <Box px={4} py={2}>
                <TextField 
                  fullWidth 
                  placeholder="Nombre de la categoría" 
                  variant="outlined" 
                  sx={{ mb: 2 }} 
                  value={nombre} 
                  onChange={(e) => setNombre(e.target.value)}
                  error={!!errors.nombre}
                  helperText={errors.nombre}
                />
                <InventarioTypeSelector
                onChange={(value) => setInventarioType(value)}
                optionLabels={[capitalizeFirstLetter(inventarioType)]}
                error={!!errors.inventarioType}
                />
                {errors.inventarioType && (
                  <Typography color="error" variant="body2">{errors.inventarioType}</Typography>
                )}
                <Typography variant="h6" fontWeight="bold" textAlign={"left"} mt={2}>Campos Personalizados</Typography>
                {errors.campos && (
                  <Typography color="error" variant="body2">{errors.campos}</Typography>
                )}
                {nuevaCategoria.map((cat, index) => (

                <Box mt={2}>
                    <DndContext
                        collisionDetection={closestCenter}
                        onDragStart={({ active }) => setActiveCategoria(cat.id)}
                        onDragEnd={handleDragEnd}
                    >
                        <SortableContext
                        items={cat.campos.map(f => f.id)}
                        strategy={verticalListSortingStrategy}
                        >
                        {cat.campos.map((field, idx) => (
                            <SortableItem
                            key={field.id}
                            field={field}
                            categoriaId={cat.id}
                            onChange={handleFieldChange}
                            onRemove={handleRemoveField}
                            handleKeyDown={handleKeyDown}
                            handleRemoveOption={handleRemoveOption}
                            error={errors[`campo_${idx}`]}
                            />
                        ))}
                        </SortableContext>

                    </DndContext>

                    <Button startIcon={<Add/>} onClick={() => handleAddField(cat.id)} variant="outlined" sx={{ mt: 2 }}>
                        Agregar campo
                    </Button>

                </Box>
                ))}
                <Box display={"flex"} flexDirection={"row"} mt={2} >
                   {errors.general && (
                     <Typography color="error" variant="body2" sx={{ mb: 1 }}>{errors.general}</Typography>
                   )}
                    <Button variant='outlined' fullWidth onClick={()=>{props.onCancel()}}>Cancelar</Button>
                    <Button fullWidth variant="contained" color='primarybutton' sx={{fontWeight:"bold", marginLeft:2}} onClick={()=>{editarCategoria()}}>Actualizar Categoría</Button>
                </Box>
            </Box>
        </Grid>
    </Grid>
                             
  );
};

export default EditarCategoria;

